import { render, staticRenderFns } from "./Contact-us.vue?vue&type=template&id=2b565ed7"
import script from "./Contact-us.vue?vue&type=script&lang=js"
export * from "./Contact-us.vue?vue&type=script&lang=js"
import style0 from "./Contact-us.vue?vue&type=style&index=0&id=2b565ed7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports